import { EquipementBase } from '../equipement';

export abstract class ComplexBase extends EquipementBase {}
